/* Recomendações inteligentes — Sul Etiquetas (ago/2026)
   Modo 'produto': quem comprou este levou junto (API /api/related/:id)
   Modo 'carrinho': upsell com base no carrinho (API /api/cart-upsell)

   O DESENHO dos cards NÃO é próprio: os ids vêm da nossa API e o HTML é
   montado pelo próprio tema, pela seção 'reco-lista', que usa o mesmo
   product-item da vitrine "Produtos vistos recentemente". Assim o visual é
   idêntico ao do resto da loja. Se algo falhar, a seção some sozinha. */
(function () {
  'use strict';

  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CHAVE_SECAO = 'reco:lista-section-id';

  function comTempo(url, opts, ms) {
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var t = setTimeout(function () { if (ctrl) ctrl.abort(); }, ms || 8000);
    opts = opts || {};
    opts.signal = ctrl ? ctrl.signal : undefined;
    return fetch(url, opts).finally(function () { clearTimeout(t); });
  }

  function json(url) {
    return comTempo(url, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    });
  }

  function idsDoCarrinho() {
    return comTempo(raiz + 'cart.js', {})
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ids = [];
        (cart.items || []).forEach(function (i) {
          if (i.product_id && ids.indexOf(i.product_id) === -1) ids.push(i.product_id);
        });
        return ids;
      })
      .catch(function () { return []; });
  }

  function guardado() {
    try { return sessionStorage.getItem(CHAVE_SECAO); } catch (e) { return null; }
  }

  function guardar(v) {
    try { sessionStorage.setItem(CHAVE_SECAO, v); } catch (e) {}
  }

  // Descobre o id real da seção de cards (muda se o tema/template for recriado).
  function descobrirSecao() {
    return comTempo(raiz + 'search?type=product&q=id%3A0', {})
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var m = html.match(/id="shopify-section-([^"]*reco_lista)"/);
        if (!m) throw new Error('secao nao encontrada');
        guardar(m[1]);
        return m[1];
      });
  }

  function urlCards(secao, ids) {
    var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
    return raiz + 'search?type=product&q=' + encodeURIComponent(q) + '&section_id=' + encodeURIComponent(secao);
  }

  function buscarCards(root, ids) {
    var secao = guardado() || root.dataset.listaSection;
    return comTempo(urlCards(secao, ids), {})
      .then(function (r) {
        if (r.ok) return r.text();
        throw new Error('http ' + r.status);
      })
      .catch(function () {
        return descobrirSecao().then(function (nova) {
          return comTempo(urlCards(nova, ids), {}).then(function (r) {
            if (!r.ok) throw new Error('http ' + r.status);
            return r.text();
          });
        });
      });
  }

  var MOEDA = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

  // Aplica o cupom de 5% criado só para aquele produto (não vaza pro resto do carrinho).
  function aplicarCupom(api, productId) {
    return fetch(api + '/api/cupom-upsell?product_id=' + productId)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || !c.codigo) return null;
        return fetch(raiz + 'discount/' + encodeURIComponent(c.codigo) + '?redirect=/cart.js', { redirect: 'follow' })
          .then(function () { return c.codigo; })
          .catch(function () { return null; });
      })
      .catch(function () { return null; });
  }

  // Adiciona sem sair/recarregar a pagina: usa o MESMO fluxo do tema (form
  // de produto) - cart/add.js com sections=mini-cart, depois cart.js, e
  // dispara cart:updated + cart:refresh no documento pra o proprio tema
  // (cart-count, cart-drawer, etc.) se atualizar sozinho.
  function adicionar(item, botao, api) {
    var variantId = item.first_variant_id;
    var textoOriginal = botao.textContent;
    botao.disabled = true;
    botao.textContent = 'Adicionando...';
    return aplicarCupom(api, item.id).then(function () {
      return fetch(raiz + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1, properties: { _reco_source: 'upsell-carrinho' } }],
          sections: ['mini-cart']
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add ' + r.status);
          return r.json();
        })
        .then(function (addResponse) {
          botao.textContent = 'Adicionado';
          return fetch(raiz + 'cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cartContent) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cartContent } }));
              cartContent.sections = addResponse.sections;
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cartContent, openMiniCart: true } }));
              setTimeout(function () {
                botao.disabled = false;
                botao.textContent = textoOriginal;
              }, 1800);
            });
        })
        .catch(function () {
          botao.disabled = false;
          botao.textContent = textoOriginal;
        });
    });
  }

  // Card enxuto para o carrinho lateral: foto limpa, título, preço e botão.
  function cardCompacto(item, api) {
    var art = document.createElement('article');
    art.className = 'reco-mini';

    var a = document.createElement('a');
    a.className = 'reco-mini__foto';
    a.href = item.url;
    if (item.image) {
      var img = new Image();
      img.src = item.image;
      img.alt = item.title;
      img.loading = 'lazy';
      a.appendChild(img);
    }
    art.appendChild(a);

    var corpo = document.createElement('div');
    corpo.className = 'reco-mini__corpo';

    var titulo = document.createElement('a');
    titulo.className = 'reco-mini__titulo';
    titulo.href = item.url;
    titulo.textContent = item.title;
    corpo.appendChild(titulo);

    var preco = document.createElement('div');
    preco.className = 'reco-mini__preco';
    if (item.price_min != null) {
      var comDesconto = item.price_min * 0.95;
      preco.innerHTML =
        '<span class="reco-mini__de">' + MOEDA.format(item.price_min) + '</span> ' +
        '<span class="reco-mini__por">' + MOEDA.format(comDesconto) + '</span> ' +
        '<span class="reco-mini__selo">-5%</span>';
    }
    corpo.appendChild(preco);

    if (item.first_variant_id) {
      var botao = document.createElement('button');
      botao.type = 'button';
      botao.className = 'reco-mini__botao button button--small button--primary';
      botao.textContent = 'Adicionar com 5% off';
      botao.addEventListener('click', function () { adicionar(item, botao, api); });
      corpo.appendChild(botao);
    }

    art.appendChild(corpo);
    return art;
  }

  function boot(root) {
    if (root.dataset.recoReady === '1') return;
    root.dataset.recoReady = '1';

    var api = (root.dataset.api || '').replace(/\/+$/, '');
    var modo = root.dataset.mode || 'produto';
    var limite = parseInt(root.dataset.limit || '4', 10);
    if (!api) return;

    var pedido;
    if (modo === 'carrinho') {
      pedido = idsDoCarrinho().then(function (ids) {
        if (!ids.length) return { items: [] };
        return json(api + '/api/cart-upsell?ids=' + ids.join(',') + '&limit=' + limite);
      });
    } else {
      var pid = root.dataset.productId;
      if (!pid) return;
      pedido = json(api + '/api/related/' + pid + '?limit=' + limite);
    }

    pedido
      .then(function (dados) {
        var itens = (dados && dados.items) || [];
        if (!itens.length) {
          root.hidden = true;
          return;
        }
        var alvoLista = root.querySelector('.reco__lista');

        if (root.dataset.compacto === '1') {
          alvoLista.innerHTML = '';
          itens.forEach(function (i) { alvoLista.appendChild(cardCompacto(i, api)); });
          root.hidden = false;
          return;
        }

        var ids = itens.map(function (i) { return i.id; });
        return buscarCards(root, ids).then(function (html) {
          var alvo = root.querySelector('.reco__lista');
          alvo.innerHTML = html;
          // o retorno vem embrulhado na div da seção; solta o conteúdo
          var wrapper = alvo.querySelector('[id^="shopify-section-"]');
          if (wrapper) alvo.innerHTML = wrapper.innerHTML;
          if (!alvo.querySelector('.product-item')) {
            root.hidden = true;
            return;
          }
          root.hidden = false;
          document.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { target: root } }));
        });
      })
      .catch(function () {
        root.hidden = true;
      });
  }

  function init() {
    document.querySelectorAll('[data-reco]').forEach(boot);
  }

  var recarregando = null;
  function recarregarCarrinho() {
    clearTimeout(recarregando);
    recarregando = setTimeout(function () {
      document.querySelectorAll('[data-reco][data-mode="carrinho"]').forEach(function (root) {
        root.dataset.recoReady = '';
        boot(root);
      });
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  ['cart:refresh', 'cart:change', 'cart:updated', 'cart:build'].forEach(function (evt) {
    document.addEventListener(evt, recarregarCarrinho);
  });

  document.addEventListener('click', function (e) {
    var alvo = e.target.closest ? e.target.closest('[data-action="open-drawer"], a[href$="/cart"], .header__cart-toggle') : null;
    if (alvo) setTimeout(recarregarCarrinho, 400);
  });
})();
